import { httpApi } from "./http.api";

// Define interfaces for the payload
export interface Question {
    text: string;
    order: number;
    id?: number;
}

export interface QuestionSetPayload {
    name: string;
    questions: Question[];
}

export const fetchAllContributorsForQuestionTemplate = (jobId: number): Promise<any> =>
    httpApi
        .get<any>(`interview/share-question-set/get-all-team-members/?resource_id=${jobId}`)
        .then(({ data }) => data);


export const ShareQuestionSet = async (payload: any): Promise<any> => {
    const data = await httpApi.post<any>("/interview/share-question-set/add-contributors/", payload);
    return data;
};


// Update the API function to use the new interface
export const createQuestionSet = (questionSetPayload: QuestionSetPayload): Promise<any> =>
    httpApi.post<any>("interview/question-sets/", questionSetPayload).then(({ data }) => data);

export const editQuestionSet = (id: number, questionSetPayload: QuestionSetPayload): Promise<any> =>
    httpApi.put<any>(`interview/question-sets/${id}/`, questionSetPayload).then(({ data }) => data);

export const getQuestionSetList = (): Promise<any> =>
    httpApi.get<any>(`interview/questions/`).then(({ data }) => data);

export const getQuestionSetDetail = (id: number): Promise<any> =>
    httpApi.get<any>(`interview/question-sets/${id}/`).then(({ data }) => data);

export const deleteQuestionSet = (id: number): Promise<any> =>
    httpApi.delete<any>(`interview/question-sets/${id}/`).then(({ data }) => data);